import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TAB_STATUS_GROUPS } from '../../mocks/showcase-tab-status-mocks'

/**
 * Mock-fed replica of every tab-status-bar state across Backup Health, Recovery
 * Environment and Failback. Its per-tab accordions are local state — the shell's
 * registry only tracks whole sections.
 */
@Component({
  selector: 'showcase-tab-status',
  templateUrl: './showcase-tab-status.component.html',
  styleUrls: ['./showcase-tab-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseTabStatusComponent {
  readonly tabStatusGroups = TAB_STATUS_GROUPS

  expandedGroups: { [key: string]: boolean } = {}

  toggleGroup(key: string): void {
    this.expandedGroups[key] = !this.expandedGroups[key]
  }
}
